import uniqueId from "lodash/uniqueId";
import { DEFAULT_MENU_WIDTH } from "./constants";
export const getSelectMenuWidthStyle = ({ isFullWidth, parentWidth, menuMaxWidth }) => {
    if (isFullWidth && parentWidth) {
        return { width: parentWidth };
    }
    if (menuMaxWidth) {
        const cssWidthString = typeof menuMaxWidth === "string" ? menuMaxWidth : `${menuMaxWidth}px`;
        return { maxWidth: cssWidthString };
    }
    return { width: DEFAULT_MENU_WIDTH };
};
export const createFlattenedArray = (options, parentOptions) => options &&
    options?.reduce((arr, currentItem) => {
        const optionKey = currentItem.id || currentItem.value || uniqueId("optionKey");
        const item = {
            ...currentItem,
            optionKey,
            ...parentOptions,
            groupLabel: parentOptions?.parentOption ? parentOptions?.parentOption.label : undefined
        };
        const hasChildOptions = (item.options !== undefined && Array.isArray(item.options)) ||
            (item.groupItems !== undefined && item.groupItems.length > 0);
        if (hasChildOptions && Array.isArray(item.options)) {
            return arr.concat([item, ...createFlattenedArray(item.options)]);
        }
        if (hasChildOptions && item.groupItems && item.groupItems.length) {
            return arr.concat([
                // { ...item },
                ...createFlattenedArray(item.groupItems, { parentKey: optionKey, parentOption: item })
            ]);
        }
        return arr.concat(item);
    }, []);
export const findValue = (value, options) => options && createFlattenedArray(options).find((option) => option.value === value);
